// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-design/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springDesignEN: PageEntry = {
  id: "post.federdesign",
  locale: "en",
  slug: "spring-design",
  seo: {
    title: "Glossary: Spring design explained simply | Dietz GmbH",
    description: "Spring design refers to the process of developing and designing a spring according to the requirements of a specific application. This process includes selecting the appropriate sp",
  },
  type: "post",
  h1: "Glossary: Spring design explained simply",
  intro: "Spring design refers to the process of developing and designing a spring according to the requirements of a specific application. This process includes selecting the appropriate spring material, defining the spring dimensions and determining the spring characteristics. Effective spring design takes into account not only the mechanical aspects, but also the environmental conditions and load requirements. The use of modern design techniques and simulations plays an important role in optimising the spring design for maximum performance and reliability.",
  blocks: [

  ],
};
